import { dark } from "@mui/material/styles/createPalette";
import Variables from "../src/scss/App.css";
import { colors } from "@mui/material";
import { Height, Padding } from "@mui/icons-material";

sessionStorage.setItem("company_code", "WSSNET");
const status = sessionStorage.getItem("themeStatus") === null ? "LightON" : sessionStorage.getItem("themeStatus");

/**
 * 切換主題
 * @param {string} status ["LightON", "LightOFF", "WSS","Utility"]
 * @description [Primary,Secondary,Error,Warning,Info,Success]，這些Default values一定要有[light,main,dark]
 * @param {object} Variables 裡面包含 "_variables.scss" 的參數
 * @param {object} Utility 開頭為通用參數，其餘為主題專用參數
 */

// /**
//  * @author Yu
//  * @date 2023/12/1
//  * @description
//  * 1. 因為defaultTheme裡面的palette的default跟soft，不是原本palette中存在的，是額外新增宣告的
//  * 2. ts內要另外宣告一個interface，去繼承上述客製的樣式
//  * 3. 不然外部使用時，會吃不到defaultTheme裡面的default跟soft
//  */
// declare module "@mui/material/styles" {
//     /**
//      * @description 客製化主題
//      * @param {string} light 主題淺色
//      * @param {string} dark 主題深色
//      * @param {string} lightHover 主題淺色hover
//      * @param {string} darkHover 主題深色hover
//      */
//     export interface CusTheme {
//         light: string;
//         dark: string;
//         lightHover: string;
//         darkHover: string;
//     }

//     /**
//      * @description soft
//      * @param {CusTheme} soft 感覺浮起來的樣式
//      */
//     export interface CusSoft {
//         soft: CusTheme;
//     }

//     /**
//      * @description default
//      * @param {CusTheme} default 預設樣式
//      */
//     export interface CusDefault {
//         default: CusTheme;
//     }

//     // 以下要去繼承上述客製的樣式
//     interface Palette extends CusSoft { }
//     interface PaletteOptions extends CusSoft { }

//     interface Palette extends CusDefault { }
//     interface PaletteOptions extends CusDefault { }
// }

// const theme = createTheme();

// theme.typography.h3 = {
//     fontSize: '1.2rem',
//     '@media (min-width:600px)': {
//         fontSize: '1.5rem',
//     },
//     [theme.breakpoints.up('md')]: {
//         fontSize: '2.4rem',
//     },
// };

type Palette = {
	[key: string]: {
		light?: string;
		main?: string;
		dark?: string;
		contrastText?: string;
		[key: string]: string | undefined; // 允許額外的 key
	};
};
type Components = {
	[componentName: string]: {
		styleOverrides: {
			[className: string]: {
				[styleKey: string]: string;
			};
		};
	};
};
export interface CustomThemeType {
	palette: Palette;
	borderRadius?: string;
	drawerWidth?: string;
	shape?: {
		[key: string]: string;
	};
	navBar?: {
		[key: string]: string;
	};
	sidebar?: {
		[key: string]: string;
	};
	dialog?: {
		[key: string]: string;
	};
	outlet?: {
		[key: string]: string;
	};
	typography?: {
		[key: string]: string;
	};
	breakpoints: {
		values: {
			xs: number;
			sm: number;
			md: number;
			lg: number;
			xl: number;
		};
	};
	LogoHeight?: string;
	components: Components;
}

/**客製化主題設定 */
export const CustomThemeTS = (() => {
	/**網購樣式*/
	const webTheme3 = {
		palette: {
			primary: {
				light: Variables["Web3__Primary"],
				main: Variables["Web3__PrimaryLight"],
			},
			secondary: {
				light: Variables["Web3__Secondary"],
				main: Variables["Web3__SecondaryLight"],
			},
			info: {
				light: Variables["Web3__Info"],
				main: Variables["Web3__InfoLight"],
			},
			secInfo: {
				light: Variables["Web3__SecInfo"],
				main: Variables["Web3__SecInfoLight"],
			},
			error: {
				light: Variables["Web3__Error"],
				main: Variables["Web3__ErrorLight"],
			},
			headerInfo: {
				light: Variables["Web3__HeaderInfo"],
				main: Variables["Web3__HeaderInfoLight"],
			},
			footerInfo: {
				light: Variables["Web3__FooterInfo"],
				main: Variables["Web3__FooterInfoLight"],
			},
		},
		typography: {
			fontFamily: ["noto sans tc", "-apple-system", "BlinkMacSystemFont", '"Segoe UI"', '"Roboto"', '"Oxygen"', '"Ubuntu"', '"Cantarell"', '"Fira Sans"', '"Droid Sans"', '"Helvetica Neue"'].join(","),
		},
		components: {
			// Paper
			MuiPaper: {
				styleOverrides: {
					root: {
						borderRadius: "0",
						background: "#fff",
					},
				},
			},
			// Button
			MuiButton: {
				defaultProps: {
					disableRipple: true, // 取消點擊波紋效果
				},
				styleOverrides: {
					root: {
						boxShadow: "none",
						transition: "transform .2s ease",
						borderRadius: "50px",
						[`&:hover`]: {
							boxShadow: "none",
						},
						[`&.active, :active`]: {
							boxShadow: "none",
							transform: "scale(.98)",
						},
						[`&.MuiButton-containedPrimary`]: {
							backgroundColor: Variables["Web3__Primary"],
						},
						[`&.MuiButton-containedSecondary`]: {
							backgroundColor: Variables["Web3__Secondary"],
						},
						// [`&.MuiButton-outlinedPrimary`]: {
						//     // borderColor: "#ede2cf",
						//     // color: "#ede2cf",
						//     // [`&:hover`]: {
						//     //     backgroundColor: "unset",
						//     // },
						// },
						// [`&.MuiButton-outlinedSecondary`]: {
						//     // borderColor: "#eeeeee",
						//     // color: "#eeeeee",
						//     // [`&:hover`]: {
						//     //     backgroundColor: "unset",
						//     // },
						// },
					},
				},
			},
			// IconButton
			MuiIconButton: {
				defaultProps: {
					disableRipple: true, // 取消點擊波紋效果
				},
				styleOverrides: {
					root: {
						boxShadow: "none",
						[`&:hover`]: {
							boxShadow: "none",
							opacity: "0.7",
						},
						[`&.active, :active`]: {
							boxShadow: "none",
							transform: "scale(.90)",
						},
					},
				},
			},
			// Input
			MuiInput: {
				styleOverrides: {
					root: {
						[`&.Mui-focused fieldset`]: {
							// borderColor: "black",
						},
					},
				},
			},
			MuiSelect: {
				styleOverrides: {
					select: {
						padding: "9px 14px", // 設置您想要的 padding 值
					},
				},
			},
			// Checkbox
			MuiCheckbox: {
				defaultProps: {
					disableRipple: true, // 取消點擊波紋效果
				},
				styleOverrides: {
					root: {
						[`&.MuiCheckbox-colorPrimary`]: {
							[`&.Mui-checked`]: {
								color: Variables["Web3__Primary"],
							},
						},
						[`&.MuiCheckbox-colorSecondary`]: {
							[`&.Mui-checked`]: {
								color: Variables["Web3__Secondary"],
							},
						},
					},
				},
			},
			// Tab
			MuiTab: {
				defaultProps: {
					disableRipple: true, // 取消點擊波紋效果
				},
				styleOverrides: {
					root: {
						[`&.MuiTab-root`]: {
							// color: "#E0BE36",
						},
						[`&.MuiTab-labelIcon`]: {
							// padding: "0",
						},
						[`&.Mui-selected`]: {
							// color: "#000000",
						},
						[`&.active, :active`]: {
							transition: "transform .3s ease",
							transform: "scale(.9)",
							boxShadow: "none",
						},
					},
				},
			},
			// Tabs
			MuiTabs: {
				styleOverrides: {
					root: {
						[`& .MuiTabs-root`]: {
							padding: "0",
						},
					},
				},
			},
			// Drawer
			MuiDrawer: {
				styleOverrides: {
					root: {
						flexShrink: 0,
						zIndex: { xs: "998" },
						[`&.left`]: {
							[`& .MuiDrawer-paper`]: {
								position: "relative",
								width: "350px",
								borderRadius: "0",
								backgroundColor: "#fff",
								color: Variables[status + "__DrawerColor"],
								boxSizing: "border-box",
								border: "none",
							},
						},
						[`&.top`]: {
							width: "300px",
							left: "unset",
							top: "96px",
							[`& .MuiDrawer-paper`]: {
								position: "relative",
								width: "300px",
								borderRadius: "0",
								backgroundColor: "#fff",
								color: Variables[status + "__DrawerColor"],
								boxSizing: "border-box",
								border: "none",
							},
						},
					},
				},
			},
			// DatePicker
			MuiPickersCalendarHeader: {
				styleOverrides: {
					switchViewButton: {
						[`&:hover`]: {
							boxShadow: "none",
						},
					},
				},
			},
			MuiPickersYear: {
				// 年份樣式
				defaultProps: {
					disableRipple: true, // 取消點擊波紋效果
				},
				styleOverrides: {
					yearButton: {
						[`&:hover`]: {
							transition: "all .3s ease",
						},
						[`&.active, :active`]: {
							transition: "transform .1s ease",
							transform: "scale(.95)",
							fontWeight: "bold",
						},
						[`&.Mui-selected`]: {
							[`&:focus`]: {
								background: Variables["Web3__Primary"],
							},
							[`&:hover`]: {
								background: Variables["Web3__Primary"],
							},
							color: Variables["Web3__HeaderInfo"],
							backgroundColor: Variables["Web3__Primary"],
							fontWeight: "bold",
						},
					},
				},
			},
			MuiPickersMonth: {
				// 月份樣式
				defaultProps: {
					disableRipple: true, // 取消點擊波紋效果
				},
				styleOverrides: {
					monthButton: {
						[`&:hover`]: {
							transition: "all .3s ease",
						},
						[`&.active, :active`]: {
							transition: "transform .1s ease",
							transform: "scale(.95)",
							fontWeight: "bold",
						},
						[`&.Mui-selected`]: {
							[`&:focus`]: {
								background: Variables["Web3__Primary"],
							},
							[`&:hover`]: {
								background: Variables["Web3__Primary"],
							},
							color: Variables["Web3__HeaderInfo"],
							backgroundColor: Variables["Web3__Primary"],
							fontWeight: "bold",
						},
					},
				},
			},
			MuiPickersDay: {
				// 日期樣式
				defaultProps: {
					disableRipple: true, // 取消點擊波紋效果
				},
				styleOverrides: {
					root: {
						[`&.MuiPickersDay-today`]: {
							background: "none",
						},
						[`&:hover`]: {
							transition: "all .3s ease",
						},
						[`&.active, :active`]: {
							transition: "transform .1s ease",
							transform: "scale(.95)",
							fontWeight: "bold",
						},
						[`&.Mui-selected`]: {
							[`&:focus`]: {
								background: Variables["Web3__Primary"],
							},
							[`&:hover`]: {
								background: Variables["Web3__Primary"],
							},
							color: Variables["Web3__HeaderInfo"],
							backgroundColor: Variables["Web3__Primary"],
							fontWeight: "bold",
						},
					},
				},
			},
		},
	};

	/**後台樣式 */
	const defaultTheme = {
		palette: {
			default: {
				light: Variables[status + "__DefaultLight"],
				main: Variables[status + "__Default"],
				dark: Variables[status + "__DefaultDark"],
				contrastText: Variables[status + "__DefaultContrastText"],
			},
			primary: {
				light: Variables[status + "__PrimaryLight"],
				main: Variables[status + "__Primary"],
				dark: Variables[status + "__PrimaryDark"],
				contrastText: Variables[status + "__PrimaryContrastText"],
			},
			secondary: {
				light: Variables[status + "__SecondaryLight"],
				main: Variables[status + "__Secondary"],
				dark: Variables[status + "__SecondaryDark"],
				contrastText: Variables[status + "__SecondaryContrastText"],
			},
			success: {
				light: Variables[status + "__BtnSuccessLight"],
				main: Variables[status + "__BtnSuccess"],
				dark: Variables[status + "__BtnSuccessDark"],
				contrastText: Variables[status + "__BtnSuccessContrastText"],
			},
			info: {
				light: Variables[status + "__BtnInfoLight"],
				main: Variables[status + "__BtnInfo"],
				dark: Variables[status + "__BtnInfoDark"],
				contrastText: Variables[status + "__BtnInfoContrastText"],
			},
			warning: {
				light: Variables[status + "__BtnWarningLight"],
				main: Variables[status + "__BtnWarning"],
				dark: Variables[status + "__BtnWarningDark"],
				contrastText: Variables[status + "__BtnWarningContrastText"],
			},
			error: {
				light: Variables[status + "__BtnErrorLight"],
				main: Variables[status + "__BtnError"],
				dark: Variables[status + "__BtnErrorDark"],
				contrastText: Variables[status + "__BtnErrorContrastText"],
			},
			soft: {
				light: Variables[status + "__BoxShadowLight"],
				dark: Variables[status + "__BoxShadowDark"],
				lightHover: Variables[status + "__boxShadowHoverLight"],
				darkHover: Variables[status + "__boxShadowHoverDark"],
			},
		},
		shape: {
			borderRadius: parseInt(Variables[status + "__borderRadius"]),
			UtilityBorderRadius: parseInt(Variables["Utility__borderRadius"]),
		},
		footer: {
			backgroundColor: Variables[status + "__FooterBackgroundColor"],
			height: parseInt(Variables[status + "__FooterHeight"]),
		},
		navBar: {
			height: parseInt(Variables["Utility__LogoHeight"]),
		},
		sidebar: {
			textColor: Variables[status + "__SidebarTextColor"],
		},
		dialog: {
			textColor: Variables[status + "__DialogWarningText"],
		},
		outlet: {
			backgroundColor: Variables[status + "__MainOutletBackgroundColor"],
			secBackgroundColor: Variables[status + "__MainSecOutletBackgroundColor"],
		},
		components: {
			MuiTypography: {
				styleOverrides: {
					root: {
						[`&.HeaderBar__logo`]: {
							width: Variables["Utility__LogoHeight"],
						},
					},
				},
			},
			MuiToolbar: {
				styleOverrides: {
					root: {
						[`&.SysHeader__Toolbar`]: {
							minHeight: "64px",
							backgroundColor: "#FFFFFF",
						},
					},
				},
			},
			MuiCssBaseline: {
				styleOverrides: {
					body: {
						color: Variables[status + "__DefaultContrastText"],
						backgroundColor: Variables[status + "__Default"],
					},
					input: {
						color: Variables[status + "__DefaultContrastText"],
					},
				},
			},
			// Progress
			MuiLinearProgress: {
				styleOverrides: {
					root: {},
				},
			},
			// // ButtonBase
			MuiButtonBase: {
				defaultProps: {
					// disableRipple: true, // 取消點擊波紋效果
				},
			},
			// Button
			MuiButton: {
				defaultProps: {
					// disableRipple: true, // 取消點擊波紋效果
				},
				styleOverrides: {
					root: {
						// Button本體於CusButton.js內調整
						// Pagination btn
						[`&.Pagination__btn`]: {
							boxShadow: "none",
							margin: "5px",
							minWidth: "35px",
							minHeight: "35px",
							borderRadius: "50%",
							color: Variables[status + "__Primary"],
							[`&.active, :active`]: {
								color: Variables[status + "__Primary"],
								backgroundColor: "rgba(120, 154, 175, 0.2)",
							},
						},
						// navBar btn
						[`&.MuiButton-text`]: {
							color: Variables[status + "__DefaultContrastText"],
							backgroundColor: "#FFFFFF",
							[`&Primary`]: {
								[`&.SysHeader__button`]: {
									display: "flex",
									borderRadius: "10px !important",
									[`&:hover`]: {
										backgroundColor: "rgba(0,0,0,0.05)",
									},
									[`&.active, :active`]: {
										backgroundColor: "rgba(0,0,0,0.05)",
										[`span`]: {
											marginTop: "1px",
											color: Variables[status + "__Secondary"],
										},
										fontWeight: "bold",
									},
									[`&.SysHeader__menuButton`]: {
										minWidth: 0,
										margin: "1em",
									},
									[`&.SysHeader__userButton`]: {
										margin: "1em",
									},
								},
							},
						},
					},
				},
			},
			// IconButton
			MuiIconButton: {
				defaultProps: {
					// disableRipple: true, // 取消點擊波紋效果
				},
				styleOverrides: {
					root: {
						// Button本體於CusButton.js內調整
					},
				},
			},
			// MuiButtonGroup
			MuiButtonGroup: {
				defaultProps: {
					// disableRipple: true, // 取消點擊波紋效果
				},
				styleOverrides: {
					root: {
						borderRadius: "15px",
					},
				},
			},
			// Toggle Button
			MuiToggleButtonGroup: {
				styleOverrides: {
					root: {
						borderRadius: "10px",
					},
				},
			},
			MuiToggleButton: {
				defaultProps: {
					// disableRipple: true, // 取消點擊波紋效果
				},
				styleOverrides: {
					root: {
						borderRadius: "10px",
						[`&.Mui-selected`]: {
							color: Variables[status + "__Secondary"],
						},
					},
				},
			},
			// ListItemButton
			MuiListItemButton: {
				defaultProps: {
					disableRipple: true, // 取消點擊波紋效果
				},
			},
			// Switch
			MuiSwitch: {
				styleOverrides: {
					root: {
						width: "40px",
						height: "24px",
						padding: "0",
						margin: "4px",
						borderRadius: "50px",
						[`& .MuiSwitch-switchBase`]: {
							padding: "0",
							margin: "2px",
							transitionDuration: "300ms",
							[`&.Mui-checked`]: {
								transform: "translateX(16px)",
								color: "#fff",
								[`& + .MuiSwitch-track`]: {
									opacity: "1",
									border: "0",
								},
								[`&.Mui-disabled + .MuiSwitch-track`]: {
									opacity: "0.5",
								},
							},
							[`&.Mui-focusVisible .MuiSwitch-thumb`]: {
								color: "#33cf4d",
								border: "6px solid #fff",
							},
							[`&.Mui-disabled + .MuiSwitch-track`]: {
								backgroundColor: Variables[status + "__DisabledColor"],
							},
						},
						[`& .MuiSwitch-thumb`]: {
							boxSizing: "border-box",
							width: "20px",
							height: "20px",
						},
						[`& .MuiSwitch-track`]: {
							borderRadius: "15px",
							backgroundColor: "#D4D5D8",
							opacity: ".5",
						},
					},
				},
			},
			// Checkbox
			MuiCheckbox: {
				styleOverrides: {
					root: {
						[`&.Mui-disabled`]: {
							color: Variables[status + "__DisabledColor"],
						},
						[`&.MuiCheckbox-colorPrimary`]: {
							[`&.Mui-checked`]: {
								color: Variables[status + "__Primary"],
							},
						},
					},
				},
			},
			// Tab
			MuiTab: {
				defaultProps: {
					disableRipple: true, // 取消點擊波紋效果
				},
				styleOverrides: {
					root: {
						[`:hover`]: {
							color: Variables[status + "__Secondary"],
						},
						[`&.MuiTab-root`]: {
							zIndex: "1",
						},
						[`&.MuiTab-labelIcon`]: {
							padding: "0",
						},
						[`&.Mui-selected`]: {
							color: Variables[status + "__Secondary"],
						},
					},
				},
			},
			// Tabs
			MuiTabs: {
				styleOverrides: {
					root: {
						margin: "0 0 1.5rem 0",
						backgroundColor: "white",
						borderRadius: "10px",
						[`& .MuiTabs-root`]: {
							padding: "0",
						},
						[`& .MuiTabs-indicator`]: {
							position: "absolute",
							top: "50%",
							transform: "translateY(-50%)",
							height: "70%",
							borderRadius: "10px",
							backgroundColor: "rgba(0,0,0,0.05)",
						},
						[`& .MuiTabs-scrollButtons.Mui-disabled`]: {
							opacity: "0.3",
						},
					},
				},
			},
			// Table
			MuiTableHead: {
				styleOverrides: {
					root: {
						backgroundColor: Variables[status + "__TableHeadBackgroundColor"],
					},
				},
			},
			MuiTableContainer: {
				styleOverrides: {
					root: {
						[`&.MuiTableContainer-root`]: {
							backgroundColor: Variables[status + "__Default"],
							borderRadius: "10px",
						},
					},
				},
			},
			MuiTableRow: {
				styleOverrides: {
					root: {
						[`&.MuiTableRow-root`]: {
							border: "none",
						},
					},
				},
			},
			MuiTableCell: {
				styleOverrides: {
					root: {
						// borderBottom: `10px solid ${Variables[status + "__Default"]}`,
						padding: "10px",
						[`&.MuiTableCell-head`]: {
							color: Variables[status + "__TableHeadColor"],
							whiteSpace: "nowrap",
							[`& .MuiCheckbox-root.MuiCheckbox-color`]: {
								[`&Primary`]: {
									color: "#fff",
									[`&.Mui-checked`]: {
										color: "#fff",
									},
								},
								[`&Secondary`]: {
									color: "#fff",
									[`&.Mui-checked`]: {
										color: "#fff",
									},
								},
							},
							[`& .MuiCheckbox-root`]: {
								padding: "0px 5px",
							},
						},
						[`& .MuiCheckbox-root`]: {
							padding: "0px 5px",
						},
						[`& .MuiAutocomplete-root`]: {
							margin: "0px",
							[`& .MuiFormControl-root`]: {
								margin: "0px",
							},
						},
					},
				},
			},
			MuiTablePagination: {
				styleOverrides: {
					root: {
						[`& .MuiToolbar-root .MuiInputBase-colorPrimary`]: {
							margin: "0",
						},
						[`& .MuiTablePagination-displayedRows`]: {
							display: "none",
						},
					},
				},
			},
			// MuiTooltip
			MuiTooltip: {
				styleOverrides: {
					tooltip: {
						borderRadius: "3px",
					},
				},
			},
			// Stepper
			MuiStepIcon: {
				styleOverrides: {
					root: {
						[`&.MuiStepIcon-root`]: {
							borderRadius: "20px",
						},
						[`&.Mui-active`]: {
							borderRadius: "20px",
						},
						[`&.Mui-completed`]: {
							color: Variables[status + "__Secondary"],
						},
					},
				},
			},
			// Input
			MuiInputBase: {
				styleOverrides: {
					root: {
						[`&.MuiInputBase-root`]: {
							backgroundColor: "#FFFFFF",
							borderRadius: "10px",
						},
						[`&.MuiOutlinedInput-root.Mui-disabled`]: {
							[`& fieldset`]: {
								border: `1px solid ${Variables[status + "__DisabledColor"]}`,
							},
						},
					},
					input: {
						[`&.MuiOutlinedInput-input.Mui-disabled`]: {
							// WebkitTextFillColor: "rgba(0, 0, 0, 0.12)",
						},
					},
				},
			},
			MuiOutlinedInput: {
				styleOverrides: {
					root: {
						[`& > fieldset > legend`]: {
							fontSize: `calc(0.75 * ${Variables["Web3__LabelFontSize"]})`,
						},
					},
				},
			},
			// Drawer
			MuiDrawer: {
				styleOverrides: {
					root: {
						flexShrink: 0,
						zIndex: { xs: "998" },
						[`&.SystemDrawer`]: {
							width: "200px",
							[`& .MuiDrawer-paper`]: {
								position: "relative",
								width: "200px",
								borderRadius: "0",
								backgroundColor: "#f5f6fa",
								color: Variables[status + "__DrawerColor"],
								boxSizing: "border-box",
								border: "none",
							},
						},
						[`&.WebDrawer3`]: {
							[`&.left`]: {
								width: "350px",
								[`& .MuiDrawer-paper`]: {
									position: "relative",
									width: "350px",
									borderRadius: "0",
									backgroundColor: "#FFFFFF",
									color: Variables[status + "__DrawerColor"],
									boxSizing: "border-box",
									border: "none",
								},
							},
							[`&.top`]: {
								width: "250px",
								[`& .MuiDrawer-paper`]: {
									position: "relative",
									width: "250px",
									borderRadius: "0",
									backgroundColor: "#FFFFFF",
									color: Variables[status + "__DrawerColor"],
									boxSizing: "border-box",
									border: "none",
								},
							},
						},
					},
				},
			},
			MuiPaper: {
				styleOverrides: {
					root: {
						[`&.SysHeader`]: {
							position: "fixed",
							boxShadow: "none",
						},
						borderRadius: "10px",
						color: Variables[status + "__Primary"],
					},
				},
			},
			MuiCard: {
				styleOverrides: {
					root: {
						borderRadius: "10px",
						backgroundColor: Variables[status + "__Default"],
						color: Variables[status + "__Primary"],
					},
				},
			},
			MuiBreadcrumbs: {
				styleOverrides: {
					root: {
						color: Variables[status + "__DefaultContrastText"],
						background: Variables[status + "__BreadcrumbsBackground"],
						height: parseInt(Variables[status + "__BreadcrumbsHeight"]),
					},
				},
			},
			MuiDivider: {
				styleOverrides: {
					root: {
						display: "block",
						width: "100%",
					},
				},
			},
			MuiFormLabel: {
				styleOverrides: {
					root: {
						[`&.MuiInputLabel-root span`]: {
							color: Variables[status + "__DefaultContrastText"],
						},
						[`&.MuiInputLabel-root.MuiInputLabel-shrink`]: {
							fontSize: Variables["Web3__LabelFontSize"],
						},
						[`&.MuiInputLabel-root.Mui-disabled`]: {
							color: Variables[status + "__DefaultContrastText"],
						},
					},
				},
			},
			MuiAlert: {
				styleOverrides: {
					root: {
						[`&.MuiAlert-standard`]: {
							[`&Default`]: {
								color: Variables[status + "__DefaultContrastText"],
								backgroundColor: Variables[status + "__DefaultLight"],
								[`& .MuiAlert-icon`]: {
									color: Variables[status + "__DefaultContrastText"],
								},
							},
						},
					},
				},
			},
			MuiChip: {
				styleOverrides: {
					root: {
						[`&.MuiChip-filled`]: {
							[`&Error`]: {
								color: Variables[status + "__ErrorContrastText"],
								backgroundColor: Variables[status + "__BtnError"],
							},
							[`&Success`]: {
								color: Variables[status + "__BtnSuccessContrastText"],
								backgroundColor: Variables[status + "__BtnSuccess"],
							},
						},
						[`&.MuiChip-outlined`]: {
							[`&Default`]: {
								backgroundColor: Variables[status + "__DefaultDarkTransparent"],
							},
							[`&Primary`]: {
								backgroundColor: Variables[status + "__PrimaryDarkTransparent"],
							},
							[`&Secondary`]: {
								backgroundColor: Variables[status + "__SecondaryDarkTransparent"],
							},
							[`&Warning`]: {
								backgroundColor: Variables[status + "__WarningDarkTransparent"],
							},
							[`&Info`]: {
								backgroundColor: Variables[status + "__infoDarkTransparent"],
							},
							[`&Error`]: {
								color: Variables[status + "__BtnError"],
								border: "1px solid " + Variables[status + "__BtnError"],
								backgroundColor: Variables[status + "__BtnErrorDarkTransparent"],
							},
							[`&Success`]: {
								color: Variables[status + "__BtnSuccess"],
								border: "1px solid " + Variables[status + "__BtnSuccess"],
								backgroundColor: Variables[status + "__BtnSuccessDarkTransparent"],
							},
						},
					},
				},
			},
			MuiPickersCalendarHeader: {
				styleOverrides: {
					label: {
						color: Variables[status + "__DefaultContrastText"],
					},
					switchViewButton: {
						color: Variables[status + "__DefaultContrastText"],
						[`&:hover`]: {
							boxShadow: "none",
						},
					},
				},
			},
			MuiPickersYear: {
				// 年份樣式
				defaultProps: {
					disableRipple: true, // 取消點擊波紋效果
				},
				styleOverrides: {
					yearButton: {
						color: Variables[status + "__DefaultContrastText"],
						[`&:hover`]: {
							transition: "all .3s ease",
							background: "none",
						},
						[`&.active, :active`]: {
							transition: "transform .1s ease",
							transform: "scale(.95)",
							fontWeight: "bold",
						},
						[`&.Mui-selected`]: {
							// [`&:focus`]: {
							//     background: "none",
							// },
							// [`&:hover`]: {
							//     background: "none",
							// },
							color: "#FFFFFF",
							backgroundColor: Variables[status + "__primary"],
							fontWeight: "bold",
						},
					},
				},
			},
			MuiPickersMonth: {
				// 月份樣式
				defaultProps: {
					disableRipple: true, // 取消點擊波紋效果
				},
				styleOverrides: {
					monthButton: {
						color: Variables[status + "__DefaultContrastText"],
						[`&:hover`]: {
							transition: "all .3s ease",
							background: "none",
						},
						[`&.active, :active`]: {
							transition: "transform .1s ease",
							transform: "scale(.95)",
							fontWeight: "bold",
						},
						[`&.Mui-selected`]: {
							// [`&:focus`]: {
							//     background: "none",
							// },
							// [`&:hover`]: {
							//     background: "none",
							// },
							color: "#FFFFFF",
							backgroundColor: Variables[status + "__primary"],
							fontWeight: "bold",
						},
					},
				},
			},
			MuiPickersDay: {
				// 日期樣式
				defaultProps: {
					disableRipple: true, // 取消點擊波紋效果
				},
				styleOverrides: {
					root: {
						color: Variables[status + "__DefaultContrastText"],
						[`&.MuiPickersDay-today`]: {
							background: "none",
							border: `1px solid ${Variables[status + "__Primary"]}`,
						},
						[`&:hover`]: {
							transition: "all .3s ease",
							background: "none",
						},
						[`&.active, :active`]: {
							transition: "transform .1s ease",
							transform: "scale(.95)",
							fontWeight: "bold",
						},
						[`&.Mui-selected`]: {
							// [`&:focus`]: {
							//     background: "none",
							// },
							// [`&:hover`]: {
							//     background: "none",
							// },
							color: "#FFFFFF",
							backgroundColor: Variables[status + "__primary"],
							fontWeight: "bold",
						},
					},
				},
			},
			MuiDateTimePicker: {
				styleOverrides: {
					root: {
						boxShadow: "none",
					},
				},
			},
			MuiDateTimePickerToolbar: {
				styleOverrides: {
					root: {
						[`&.MuiPickersToolbar-root *`]: {
							boxShadow: "none",
						},
					},
				},
			},
			MuiDateTimePickerTabs: {
				styleOverrides: {
					root: {
						boxShadow: "none",
						[`&.MuiDateTimePickerTabs-root *`]: {
							boxShadow: "none",
						},
					},
				},
			},
			MuiClock: {
				styleOverrides: {
					root: {
						[`&.MuiClock-root > *`]: {
							backgroundColor: Variables[status + "__Default"],
						},
						[`&.MuiClockPointer-root`]: {
							backgroundColor: "red",
						},
					},
				},
			},
		},
	};

	/**酒單樣式(1) */
	const Menu1 = {
		palette: {
			primary: {
				light: Variables["Menu1__PrimaryLight"],
				main: Variables["Menu1__Primary"],
				dark: Variables["Menu1__PrimaryDark"],
				contrastText: Variables["Menu1__PrimaryContrastText"],
			},
			secondary: {
				light: Variables["Menu1__SecondaryLight"],
				main: Variables["Menu1__Secondary"],
				dark: Variables["Menu1__SecondaryDark"],
				contrastText: Variables["Menu1__SecondaryContrastText"],
			},
			info: {
				light: Variables["Menu1__InfoLight"],
				main: Variables["Menu1__Info"],
				dark: Variables["Menu1__InfoDark"],
				contrastText: Variables["Menu1__InfoContrastText"],
			},
			error: {
				light: Variables["Menu1__ErrorLight"],
				main: Variables["Menu1__Error"],
				dark: Variables["Menu1__ErrorDark"],
				darkless: Variables["Menu1__ErrorDarkLess"],
				contrastText: Variables["Menu1__ErrorContrastText"],
			},
		},
		// breakpoints: {
		//     values: {
		//         xs: 0,
		//         sm: 600,
		//         md: 960,
		//         lg: 1280,
		//         xl: 1920,
		//     },
		// },
		borderRadius: Variables["Menu1__BorderRadius"],
		drawerWidth: Variables["Menu1__DrawerWidth"],
		LogoHeight: Variables["Menu1__NavHeightSm"],
		typography: {
			fontFamily: '"Lexend", "Roboto", "Helvetica", "Arial", sans-serif',
		},
		components: {
			MuiCssBaseline: {
				styleOverrides: {
					[`.Menu1__Main`]: {
						backgroundColor: "#fff",
						height: `calc(100% - ${Variables["Menu1__NavHeightMd"]})`,
						borderRadius: Variables["Menu1__BorderRadius"],
						overflow: "hidden",
						[`& > .Menu1__MainOverflow`]: {
							height: `calc(100% - ${Variables["Menu1__NavHeightMd"]} - 68px)`,
							overflow: "auto",
							padding: "0.25rem",
							margin: "0.5rem 1rem",
						},
					},
					[`&.Menu1__Strip`]: {
						width: "0.5rem",
						height: "103%",
						borderRadius: "4px",
						position: "absolute",
						top: "-5px",
						transition: "all 0.1s ease",
						marginRight: "1.5rem",
					},
					[`&.Menu1__DetailImage`]: {
						width: "auto",
						height: "100%",
						objectFit: "contain",
					},
					[`&.Menu1__AppBarMain_bg`]: {
						backgroundColor: Variables["Menu1__Secondary"],
					},
				},
			},
			MuiCard: {
				styleOverrides: {
					root: {
						[`&.Menu1__DetailCard`]: {
							marginLeft: "1.5rem",
							backgroundColor: Variables["Menu1__Secondary"],
							border: "none",
						},
					},
				},
			},
			MuiFormControlLabel: {
				styleOverrides: {
					root: {
						[`& .MuiFormControlLabel-label`]: {
							fontSize: "0.94rem",
							// [`@media (max-width: 379px)`]: {
							//     fontSize: "0.94rem", // xs 裝置
							// },
						},
					},
				},
			},
			MuiSlider: {
				styleOverrides: {
					root: {
						height: "2px",
					},
				},
			},
			MuiButtonBase: {
				styleOverrides: {
					root: {
						["&.Menu1__MuiListItemButton"]: {
							padding: "0 0px 0 16px",
						},
					},
				},
			},
			MuiListSubheader: {
				styleOverrides: {
					root: {
						color: Variables["Menu1__Error"],
						fontWeight: "bold",
						fontSize: "1rem",
						backgroundColor: Variables["Menu1__Secondary"],
					},
				},
			},
			MuiList: {
				styleOverrides: {
					root: {
						backgroundColor: Variables["Menu1__Secondary"] + " !important",
					},
				},
			},
			MuiAppBar: {
				styleOverrides: {
					root: {
						[`&.Menu1__AppBar`]: {
							backgroundColor: Variables["Menu1__Secondary"],
							boxShadow: "none",
						},
					},
				},
			},
			MuiDrawer: {
				styleOverrides: {
					root: {
						width: Variables["Menu1__DrawerWidth"],
					},
					paper: {
						backgroundColor: Variables["Menu1__Secondary"],
						borderRight: "none",
						color: Variables["Menu1__ErrorDarkLess"],
						width: Variables["Menu1__DrawerWidth"],
						boxSizing: "border-box",
						flexShrink: "0",
					},
				},
			},
			MuiIconButton: {
				styleOverrides: {
					root: {
						[`&.Menu1__AppBarSeidebarButton`]: {
							// color: Variables["Menu1__Primary"]
						},
					},
				},
			},
		},
	};

	return {
		defaultTheme,
		webTheme3,
		Menu1,
	};
})();
